import React from "react";
import { Container, Card } from "react-bootstrap";
import AnimatedCard from "./AnimatedSection";
import "../Styles/Testimonials.css";

// Keep all your individual imports
import img1 from "../Assets/1.png";
import img2 from "../Assets/2.png";
import img3 from "../Assets/3.png";
import img4 from "../Assets/alaa.png";
import img5 from "../Assets/kosar.png";
import lawen from "../Assets/lawen.png";
import hanan from "../Assets/hana.png";
import barzan from "../Assets/barzan.png";
import rami from "../Assets/rami.png"
import img6 from "../Assets/walid.png";
import img7 from "../Assets/maz.png";
import d5 from "../Assets/d5.png";
import img8 from "../Assets/4.png";
import img9 from "../Assets/5.png";
import img10 from "../Assets/6.png";
import img11 from "../Assets/rosh.png";
import img12 from "../Assets/hal.png";
import img13 from "../Assets/9.png";
import img14 from "../Assets/10.png";
import img15 from "../Assets/15.png";
import img16 from "../Assets/11.png";
import img17 from "../Assets/14.png";
import img18 from "../Assets/13.png";
import Saadi from "../Assets/saadi.png";
import Farhad from "../Assets/farhad.png";
import Mushir from "../Assets/mushir.png";
import Bilal from "../Assets/bilal.png";
import Jinan from "../Assets/jinan.png";
import elakh from "../Assets/elakh.png";
import arya from "../Assets/arya.png";
import aryu from "../Assets/aryu.png";
import fenk from "../Assets/fenk.png";
import ahmad from "../Assets/ahmad.png";
import falah from "../Assets/falah.png"
import nasih from "../Assets/nasih.png"
import kazhwast from "../Assets/kazhwast.png"
import snoor from "../Assets/snur.png"
import sahar from "../Assets/sahar.png";
import larin from "../Assets/larin.png"
import nazanin from "../Assets/nazanin.png"

function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: "Dr.Lawen Dizayee",
      image: lawen,
      text: "Epilyum delivers advanced aesthetic technology with precision, safety, and reliable performance"
    },
     {
      id: 2,
      name: "Dr.Barzan Al-Mirany",
      image: barzan,
      text: "Epilyum delivers quick, visible results, which greatly boosts patient satisfaction.”"
    },  {
      id: 1,
      name: "Dr.Zryan Xoshnaw",
      image: img1,
      text: "Epilyum has revolutionized my practice! The results are incredible, and my patients are thrilled."
    },
    {
      id: 3,
      name: "Dr.Hanan mohammed",
      image: hanan,
      text: "Early results with Epilyum are noticeably high, helping patients feel confident about the treatment from session one",
    },
     
    {
      id: 2,
      name: "Dr.Shilan Barnzjy",
      image: img2,
      text: "I highly recommend Epilyum for clinics seeking effective and reliable laser hair removal technology."
    },
    {
      id: 3,
      name: "Dr.Sherko Wais",
      image: img3,
      text: "Outstanding experience! The device is top-notch and the support from Epilyum is excellent."
    },
    {
      id: 4,
      name: "Dr.Alaa Alsumadi",
      image: img4,
      text: "Exceptional performance and reliable results with Epilyum."
    },
    {
      id: 5,
      name: "Dr.rami affas",
      image: rami,
      text: "Highly efficient and safe for all skin types. Great experience!"
    },
    {
      id: 6,
      name: "Dr.Walid Saadi",
      image: img6,
      text: "A game-changer in laser hair removal technology. Very satisfied."
    },
    {
      id: 7,
      name: "Dr.Mazn Dizayi",
      image: img7,
      text: "Remarkably effective with minimal discomfort, suitable for all skin tones and types."
    },
    {
      id: 8,
      name: "Dr.Maha alobaidi",
      image: d5,
      text: "Epilyum offers advanced hair removal with safety and precision, ideal for every skin type."
    },
    {
      id: 9,
      name: "Dr.Halwan Azad",
      image: img12,
      text: "Epilyum ensures exceptional results with minimal discomfort, redefining hair removal for your patients."
    },
    {
      id: 10,
      name: "Dr.Karzan Zrar",
      image: img10,
      text: "Designed for experts, Epilyum laser combine power and gentleness, catering to diverse patient needs."
    },
    {
      id: 11,
      name: "Dr.Roshan Dara",
      image: img11,
      text: "Bring the future of hair removal to your clinic with Epilyum laser technology."
    },
    {
      id: 12,
      name: "Dr.Hanar Ahmed",
      image: img14,
      text: "Achieve superior results with Epilyum's advanced technology—where safety meets effectiveness."
    },
    {
      id: 13,
      name: "Dr.Eman Hasan",
      image: img13,
      text: "Epilyum laser is tailored for precision, efficiency, and patient comfort in every session."
    },
    {
      id: 14,
      name: "Dr.Hawar Jalil",
      image: img16,
      text: "Transform your clinic experience with Epilyum's innovative laser hair removal technology."
    },
    {
      id: 15,
      name: "Dr.Hoshmand Ali",
      image: img9,
      text: "Epilyum: Where innovation meets reliability for seamless hair removal treatments your patients will love."
    },
    {
      id: 16,
      name: "Dr.Amanj Hama Salh",
      image: img8,
      text: "Trusted by professionals, Epilyum delivers precision and patient satisfaction in every treatment."
    },
    {
      id: 17,
      name: "Dr.Shaxawan Mohammed",
      image: img15,
      text: "Enhance your clinic with Epilyum laser technology, ensuring safe and effective hair removal for all skin tones."
    },
    {
      id: 18,
      name: "Dr.Chiman Yousif",
      image: img17,
      text: "Epilyum offers advanced hair removal with safety and precision, ideal for every skin type."
    },
    {
      id: 19,
      name: "Dr.Pary Osman",
      image: img18,
      text: "Epilyum redefines laser hair removal with technology that adapts to all skin types and tones."
    },
    {
      id: 20,
      name: "Dr.Bilal Rashed",
      image: Bilal,
      text: "Epilyum offers a personalized laser hair removal experience, combining technology and care for optimal results."
    },
    {
      id: 21,
      name: "Dr.Farhad Jaff",
      image: Farhad,
      text: "Smooth, radiant skin is within reach with Epilyum's laser hair removal, designed for all skin types."
    },
    {
      id: 22,
      name: "Dr.Mushir Ibrahem",
      image: Mushir,
      text: "Epilyum's laser hair removal treatments are crafted to provide safe and effective care for every skin tone."
    },
    {
      id: 23,
      name: "Dr.Jinan Jalil",
      image: Jinan,
      text: "Tailored for your needs, Epilyum's laser hair removal delivers exceptional results no matter your skin type."
    },
    {
      id: 24,
      name: "Dr.Saadi Xalil",
      image: Saadi,
      text: "With Epilyum, achieve hair-free skin through laser treatments that prioritize comfort and effectiveness."
    },
    {
      id: 25,
      name: "Dr.fenk jabar",
      image: fenk,
      text: "For doctors, safety comes first—and Epilyum meets the highest standards in laser hair removal technology."
    },
    {
      id: 26,
      name: "Dr.snoor aqrawi",
      image: snoor,
      text: "Epilyum gives us the confidence to treat sensitive areas with excellent results and patient satisfaction."
    },
    {
      id: 27,
      name: "Dr.kazhwast hama rash",
      image: kazhwast,
      text: "We rely on Epilyums precision to target hair follicles without harming the surrounding skin."
    },
    {
      id: 28,
      name: "Dr.ary younis",
      image: aryu,
      text: "Using Epilyum means fewer sessions, faster treatments, and happier patients."
    },
    {
      id: 29,
      name: "Dr.ary azad",
      image: arya,
      text: "I recommend Epilyum to anyone seeking laser treatments that are both effective and gentle on the skin."
    },
    {
      id: 30,
      name: "Dr.falah ghazi",
      image: falah,
      text: "Epilyum devices are designed to treat all skin tones effectively and safely—something we value highly in dermatology."
    },
    {
      id: 31,
      name: "Dr.larin othman",
      image: larin,
      text: "Our clients trust Epilyum because its medically approved and delivers visible results after just a few sessions."
    },
    {
      id: 32,
      name: "Dr.ahmad jamal",
      image: ahmad,
      text: "With Epilyum, patients enjoy a faster, more comfortable laser experience that really works."
    },
    {
      id: 33,
      name: "Dr.nasih haji",
      image: nasih,
      text: "In our practice, Epilyum has become the gold standard for pain-free, professional laser treatments"
    },
    {
      id: 34,
      name: "Dr.sahar chawshly",
      image: sahar,
      text: "We chose Epilyum for our clinic because it offers powerful results with minimal discomfort."
    },
    {
      id: 35,
      name: "Dr.Elakh Qadir",
      image: elakh,
      text: "Epilyum combines advanced technology with medical expertise to deliver smooth, hair-free skin safely."
    },
    {
      id: 36,
      name: "Dr.nazanin Sadiq",
      image: nazanin,
      text: "At Epilyum, we ensure every laser session is tailored to your skin type for safe and long-lasting results."
    }
  ];

  return (
    <section>
      <Container id="testimonials" className="my-5">
        <h2 className="testimonials-title">
          What Our Doctors Say
        </h2>
        
        <div className="scrolling-wrapper">
          {testimonials.map((testimonial, index) => (
            <div className="scrolling-card" key={testimonial.id}>
              <AnimatedCard delay={0.1 * (index % 5)}>
                <Card className="testimonial-card">
                  <Card.Img 
                    variant="top" 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    loading="lazy"
                  />
                  <Card.Body>
                    <Card.Title>{testimonial.name}</Card.Title>
                    <Card.Text>"{testimonial.text}"</Card.Text>
                  </Card.Body>
                </Card>
              </AnimatedCard>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Testimonials;